import { useQueryClient as t, useMutation as i } from "@tanstack/react-query";
import { u as a } from "./use-account.DkVfV1FC.js";
import { q as r } from "./stale.constant.De1PuSBj.js";
const o = (e) => {
  const u = t();
  return i({
    ...e,
    onSuccess: (...s) => {
      u.invalidateQueries({ queryKey: r.user("FULL") }), u.invalidateQueries({ queryKey: r.userRelationships }), typeof (e == null ? void 0 : e.onSuccess) == "function" && e.onSuccess(...s);
    },
    mutationFn: a
  });
};
export {
  o as u
};
